export function closeIframe() {
    window.parent.postMessage("RoomEnded", "*");
}

export function isInsideIframe() {
    return window.self !== window.top;
}